import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../features/Home.vue'
import About from '../features/About.vue'
import Birds from '../features/Birds.vue'
import Mammal from '../features/Mammal.vue'
import Contact from '../features/Contact.vue'
import ViewPhotos from '../features/ViewPhotos.vue'
import Carousel from '../features/Carousel.vue'
import CarouselTravel from '../features/CarouselTravel.vue'
import CarouselRecent from '../features/CarouselRecent.vue'
import Portfolio from '../features/Portfolio.vue'
import Travel from '../features/Travel.vue'
import Recent from '../features/Recent.vue'
import TravelPhotos from '../features/TravelPhotos.vue'
import i18n from '../i18n.js'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: `/${i18n.locale}`
    },
    {
      path: '/:lang',
      component: {
        render(c) {return c('router-view')}
      },
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: 'about',
          name: 'About',
          component: About
        },
        {
          path: 'birds',
          name: 'Birds',
          component: Birds
        },
        {
          path: 'mammal',
          name: 'Mammal',
          component: Mammal
        },
        {
          path: 'portfolio',
          name: 'Portfolio',
          component: Portfolio
        },
        {
          path: 'recent',
          name: 'Recent',
          component: Recent
        },
        {
          path: 'travel',
          name: 'Travel',
          component: Travel
        },
        {
          path: 'contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: 'travel/:id',
          name: 'TravelPhotos',
          component: TravelPhotos
        },
        {
          path: ':species',
          name: 'ViewPhotos',
          component: ViewPhotos
        },
        {
          path: 'birds/:species/:id',
          name: 'Carousel',
          component: Carousel
        },
        {
          path: 'travel/carousel/:id/:index',
          name: 'CarouselTravel',
          component: CarouselTravel
        },
        {
          path: 'recent/carousel/:date/:index',
          name: 'CarouselRecent',
          component: CarouselRecent
        }
      ]
    }
  ]
})


